import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_CONFIG from './config/api';
import CreationWizard, { ReviewCard } from './CreationWizard';

const normalizarCnhParaSelect = (cnh, possuiCnh) => {
  if (typeof possuiCnh === 'boolean') {
    return possuiCnh ? 'sim' : 'nao';
  }

  const valor = `${cnh || ''}`.trim().toLowerCase();
  if (['sim', 's', 'true', '1'].includes(valor)) return 'sim';
  if (['nao', 'não', 'n', 'false', '0'].includes(valor)) return 'nao';
  return '';
};

const PreencherFicha = ({ isOpen, onClose, ficha, onSuccess, userLogado }) => {
  const [currentSection, setCurrentSection] = useState(0);
  const [formData, setFormData] = useState({
    nomeCompleto: '',
    cpf: '',
    dataNascimento: '',
    rg: '',
    nomePai: '',
    nomeMae: '',
    celular: '',
    cnh: '',
    telefone: '',
    email: '',
    estadoCivil: '',
    naturalidade: '',
    usuario_id: '',
    
    cep: '',
    endereco: '',
    numero: '',
    complemento: '',
    bairro: '',
    cidade: '',
    estado: '',
    
    tipoTrabalho: '',
    empresaTrabalha: '',
    cargo: '',
    telefoneEmpresa: '',
    enderecoEmpresa: '',
    tempoServico: '',
    salario: '',
    cnpjProprietario: '',
    
    observacoes: ''
  });


  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [buscandoCep, setBuscandoCep] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [loadingUsuarios, setLoadingUsuarios] = useState(false);

  const sections = [
    {
      title: 'Dados Pessoais',
      fields: ['usuario_id', 'nomeCompleto', 'cpf', 'rg', 'dataNascimento', 'nomePai', 'nomeMae', 'celular', 'email', 'cnh', 'estadoCivil', 'naturalidade']
    },
    {
      title: 'Endereço',
      fields: ['cep', 'endereco', 'numero', 'complemento', 'bairro', 'cidade', 'estado']
    },
    {
      title: 'Dados Profissionais',
      fields: ['tipoTrabalho', 'empresaTrabalha', 'cargo', 'telefoneEmpresa', 'enderecoEmpresa', 'tempoServico', 'salario', 'cnpjProprietario']
    },
    {
      title: 'Observações',
      fields: ['observacoes']
    },
    {
      title: 'Revisão',
      fields: []
    }
  ];

  useEffect(() => {
    const carregarUsuarios = async () => {
      if (!userLogado || (userLogado.cargo !== 'Gerente' && userLogado.cargo !== 'Analista')) {
        return;
      }

      setLoadingUsuarios(true);
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_CONFIG.API_URL}/usuarios`, {
          params: {
            status: 'ativo',
            limit: 5000
          },
          headers: { 'Authorization': `Bearer ${token}` }
        });
        
        if (response.data.success) {
          const listaBase = Array.isArray(response.data.data) ? response.data.data : [];
          const vendedorFicha = ficha?.vendedor_id && typeof ficha.vendedor_id === 'object'
            ? {
                _id: ficha.vendedor_id._id,
                nome: ficha.vendedor_id.nome || ficha.vendedor_nome || 'Usuário sem nome',
                status: ficha.vendedor_id.status || 'inativo',
                cargo: ficha.vendedor_id.cargo,
                tipo: ficha.vendedor_id.tipo
              }
            : null;

          const listaFinal = [...listaBase];
          if (vendedorFicha?._id && !listaFinal.some((u) => `${u._id || u.id}` === `${vendedorFicha._id}`)) {
            listaFinal.push(vendedorFicha);
          }

          listaFinal.sort((a, b) => `${a.nome || ''}`.localeCompare(`${b.nome || ''}`, 'pt-BR'));
          setUsuarios(listaFinal);
        }
      } catch (error) {
      } finally {
        setLoadingUsuarios(false);
      }
    };

    if (isOpen) {
      carregarUsuarios();
    }
  }, [isOpen, userLogado, ficha]);

  useEffect(() => {
    if (isOpen && ficha) {
      setFormData({
        nomeCompleto: ficha.cliente?.nome || '',
        cpf: ficha.cliente?.cpf || '',
        dataNascimento: ficha.cliente?.data_nascimento ? new Date(ficha.cliente.data_nascimento).toISOString().split('T')[0] : '',
        rg: ficha.cliente?.rg || '',
        nomePai: ficha.cliente?.nome_pai || '',
        nomeMae: ficha.cliente?.nome_mae || '',
        celular: ficha.cliente?.celular || ficha.cliente?.telefone || '',
        telefone: ficha.cliente?.telefone || '',
        email: ficha.cliente?.email || '',
        cnh: normalizarCnhParaSelect(ficha.cliente?.cnh, ficha.cliente?.possui_cnh),
        estadoCivil: ficha.cliente?.estado_civil || '',
        ufNascimento: ficha.cliente?.uf_nascimento || '',
        cidadeNascimento: ficha.cliente?.cidade_nascimento || '',
        naturalidade: ficha.cliente?.naturalidade || '',
        usuario_id: ficha.vendedor_id?._id || ficha.vendedor_id || ficha.usuario_id?._id || ficha.usuario_id || '',
        
        cep: ficha.cliente?.endereco?.cep || '',
        endereco: ficha.cliente?.endereco?.rua || '',
        numero: ficha.cliente?.endereco?.numero || '',
        complemento: ficha.cliente?.endereco?.complemento || '',
        bairro: ficha.cliente?.endereco?.bairro || '',
        cidade: ficha.cliente?.endereco?.cidade || '',
        estado: ficha.cliente?.endereco?.estado || '',
        
        tipoTrabalho: ficha.dados_profissionais?.tipo_trabalho || '',
        empresaTrabalha: ficha.dados_profissionais?.empresa || '',
        cargo: ficha.dados_profissionais?.cargo || '',
        telefoneEmpresa: ficha.dados_profissionais?.telefone || '',
        enderecoEmpresa: ficha.dados_profissionais?.endereco || '',
        tempoServico: ficha.dados_profissionais?.tempo_servico || '',
        salario: ficha.dados_profissionais?.salario || '',
        cnpjProprietario: ficha.dados_profissionais?.cnpj || '',
        
        observacoes: ficha.observacoes || ''
      });
      setCurrentSection(0);
    }
  }, [isOpen, ficha]);

  const formatCEP = (value) => {
    const numericValue = value.replace(/\D/g, '');
    return numericValue.replace(/(\d{5})(\d)/, '$1-$2').slice(0, 9);
  };

  const formatTelefone = (value) => {
    const numericValue = value.replace(/\D/g, '');
    return numericValue.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2').slice(0, 15);
  };

  const formatMoeda = (value) => {
    const numericValue = value.replace(/\D/g, '');
    const numberValue = parseFloat(numericValue) / 100;
    return numberValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (name === 'celular' || name === 'telefone' || name === 'telefoneEmpresa') {
      newValue = formatTelefone(value);
    } else if (name === 'cep') {
      newValue = formatCEP(value);
      if (newValue.replace(/\D/g, '').length === 8) {
        buscarCep(newValue);
      }
    } else if (name === 'salario') {
      newValue = formatMoeda(value);
    }

    setFormData(prev => ({ ...prev, [name]: newValue }));
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const buscarCep = async (cep) => {
    const cepLimpo = cep.replace(/\D/g, '');
    if (cepLimpo.length !== 8) return;
    
    setBuscandoCep(true);
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cepLimpo}/json/`);
      if (!response.data.erro) {
        setFormData(prev => ({
          ...prev,
          endereco: response.data.logradouro || '',
          bairro: response.data.bairro || '',
          cidade: response.data.localidade || '',
          estado: response.data.uf || ''
        }));
      }
    } catch (error) {
    } finally {
      setBuscandoCep(false);
    }
  };

  const validateSection = (sectionIndex) => {
    const newErrors = {};
    const section = sections[sectionIndex];
    const requiredFields = {
      nomeCompleto: 'Nome completo',
      cpf: 'CPF',
      rg: 'RG',
      dataNascimento: 'Data de nascimento',
      nomePai: 'Nome do pai',
      nomeMae: 'Nome da mãe',
      celular: 'Telefone',
      email: 'Email',
      cnh: 'CNH',
      estadoCivil: 'Estado civil',
      naturalidade: 'Naturalidade',
      cep: 'CEP',
      endereco: 'Endereço',
      numero: 'Número',
      complemento: 'Complemento',
      bairro: 'Bairro',
      cidade: 'Cidade',
      estado: 'Estado',
      tipoTrabalho: 'Tipo de trabalho',
      empresaTrabalha: 'Empresa',
      cargo: 'Cargo',
      telefoneEmpresa: 'Telefone da empresa',
      enderecoEmpresa: 'Endereço da empresa',
      tempoServico: 'Tempo de serviço',
      salario: 'Salário'
    };

    if (fieldObrigatorioResponsavel() && section.fields.includes('usuario_id') && !formData.usuario_id) {
      newErrors.usuario_id = 'Vendedor responsável é obrigatório';
    }

    section.fields.forEach(field => {
      if (requiredFields[field] && !formData[field]?.trim()) {
        newErrors[field] = `${requiredFields[field]} é obrigatório`;
      }
    });

    if (formData.tipoTrabalho === 'autonomo_cnpj' && !formData.cnpjProprietario?.trim()) {
      newErrors.cnpjProprietario = 'CNPJ é obrigatório';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const fieldObrigatorioResponsavel = () => Boolean(
    userLogado && ['Gerente', 'Analista'].includes(userLogado.cargo)
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    if (currentSection < sections.length - 1) {
      if (validateSection(currentSection)) setCurrentSection(currentSection + 1);
      return;
    }

    for (let index = 0; index < sections.length - 1; index += 1) {
      if (!validateSection(index)) {
        setCurrentSection(index);
        return;
      }
    }

    setLoading(true);
    
    try {
      const token = localStorage.getItem('token');
      
      const dadosAtualizados = {
        cliente: {
          nome: formData.nomeCompleto,
          cpf: formData.cpf,
          rg: formData.rg,
          data_nascimento: formData.dataNascimento,
          telefone: formData.celular,
          celular: formData.celular,
          email: formData.email,
          nome_pai: formData.nomePai,
          nome_mae: formData.nomeMae,
          cnh: formData.cnh,
          possui_cnh: formData.cnh === 'sim',
          estado_civil: formData.estadoCivil,
          uf_nascimento: formData.ufNascimento,
          cidade_nascimento: formData.cidadeNascimento,
          naturalidade: formData.naturalidade,
          endereco: {
            cep: formData.cep,
            rua: formData.endereco,
            numero: formData.numero,
            bairro: formData.bairro,
            cidade: formData.cidade,
            estado: formData.estado,
            complemento: formData.complemento
          }
        },
        dados_profissionais: {
          tipo_trabalho: formData.tipoTrabalho,
          empresa: formData.empresaTrabalha,
          telefone: formData.telefoneEmpresa,
          endereco: formData.enderecoEmpresa,
          cargo: formData.cargo,
          tempo_servico: formData.tempoServico,
          salario: formData.salario,
          cnpj: formData.cnpjProprietario
        },
        observacoes: formData.observacoes,
        status: ''
      };

      if (userLogado && (userLogado.cargo === 'Gerente' || userLogado.cargo === 'Analista') && formData.usuario_id) {
        dadosAtualizados.usuario_id = formData.usuario_id;
        dadosAtualizados.vendedor_id = formData.usuario_id;
        const vendedorSelecionado = usuarios.find((u) => `${u._id || u.id}` === `${formData.usuario_id}`);
        dadosAtualizados.vendedor_nome = vendedorSelecionado?.nome || '';
      }

      const response = await axios.put(
        `${API_CONFIG.API_URL}/fichas/${ficha._id}`,
        dadosAtualizados,
        { headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' } }
      );

      if (response.data.success) {
        onSuccess('Ficha preenchida com sucesso!');
        onClose();
      }
    } catch (error) {
      setErrors({ geral: error.response?.data?.message || 'Erro ao preencher ficha. Tente novamente.' });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setFormData({
      nomeCompleto: '', cpf: '', dataNascimento: '', rg: '', nomePai: '', nomeMae: '', celular: '',
      cnh: '', telefone: '', email: '', estadoCivil: '', naturalidade: '', ufNascimento: '', cidadeNascimento: '', usuario_id: '',
      cep: '', endereco: '', numero: '', complemento: '', bairro: '', cidade: '', estado: '',
      tipoTrabalho: '', empresaTrabalha: '', cargo: '', telefoneEmpresa: '', enderecoEmpresa: '',
      tempoServico: '', salario: '', cnpjProprietario: '', observacoes: ''
    });
    setErrors({});
    setCurrentSection(0);
    onClose();
  };

  if (!isOpen || !ficha) return null;

  return (
    <CreationWizard
      title={`Editar ficha${ficha.fichaId ? ` · ${ficha.fichaId}` : ''}`}
      steps={['Dados', 'Endereço', 'Profissional', 'Observações', 'Revisão']}
      step={currentSection}
      onStep={setCurrentSection}
      onClose={handleClose}
      onSubmit={handleSubmit}
      busy={loading}
      submitLabel="Salvar ficha"
      error={errors.geral}
      headingAside={currentSection === 0 && fieldObrigatorioResponsavel() && (
        <div className="field-group">
          <label>Vendedor Responsável <span className="required">*</span></label>
          {loadingUsuarios ? (
            <input type="text" value="Carregando..." disabled className="input-disabled" />
          ) : (
            <select
              name="usuario_id"
              value={formData.usuario_id}
              onChange={handleChange}
              className={errors.usuario_id ? 'input-error' : ''}
            >
              <option value="">Selecione um vendedor</option>
              {usuarios.map(u => {
                const idUsuario = u._id || u.id;
                const ativo = `${u.status || ''}`.toLowerCase() === 'ativo';
                return <option key={idUsuario} value={idUsuario}>{u.nome}{ativo ? '' : ' (inativo)'}</option>;
              })}
            </select>
          )}
          {errors.usuario_id && <span className="field-error">{errors.usuario_id}</span>}
        </div>
      )}
    >
            {currentSection === 0 && (
              <>
                <div className="field-row">
                  <div className="field-group">
                    <label>Nome Completo <span className="required">*</span></label>
                    <input
                      type="text"
                      name="nomeCompleto"
                      value={formData.nomeCompleto}
                      onChange={handleChange}
                      placeholder="ORLANDO TREVISAN"
                      className={errors.nomeCompleto ? 'input-error' : ''}
                    />
                    {errors.nomeCompleto && <span className="field-error">{errors.nomeCompleto}</span>}
                  </div>
                  <div className="field-group">
                    <label>CPF <span className="required">*</span></label>
                    <input type="text" value={formData.cpf} disabled className="input-disabled" />
                  </div>
                </div>

                <div className="field-row">
                  <div className="field-group">
                    <label>RG <span className="required">*</span></label>
                    <input
                      type="text"
                      name="rg"
                      value={formData.rg}
                      onChange={handleChange}
                      placeholder="Digite o RG"
                      inputMode="numeric"
                      className={errors.rg ? 'input-error' : ''}
                    />
                    {errors.rg && <span className="field-error">{errors.rg}</span>}
                  </div>
                  <div className="field-group">
                    <label>Data de Nascimento <span className="required">*</span></label>
                    <input
                      type="date"
                      name="dataNascimento"
                      value={formData.dataNascimento}
                      onChange={handleChange}
                      className={errors.dataNascimento ? 'input-error' : ''}
                    />
                    {errors.dataNascimento && <span className="field-error">{errors.dataNascimento}</span>}
                  </div>
                </div>

                <div className="field-row">
                  <div className="field-group">
                    <label>Nome do Pai <span className="required">*</span></label>
                    <input
                      type="text"
                      name="nomePai"
                      value={formData.nomePai}
                      onChange={handleChange}
                      placeholder="Nome completo"
                      className={errors.nomePai ? 'input-error' : ''}
                    />
                    {errors.nomePai && <span className="field-error">{errors.nomePai}</span>}
                  </div>
                  <div className="field-group">
                    <label>Nome da Mãe <span className="required">*</span></label>
                    <input
                      type="text"
                      name="nomeMae"
                      value={formData.nomeMae}
                      onChange={handleChange}
                      placeholder="Nome completo"
                      className={errors.nomeMae ? 'input-error' : ''}
                    />
                    {errors.nomeMae && <span className="field-error">{errors.nomeMae}</span>}
                  </div>
                </div>

                <div className="field-row">
                  <div className="field-group">
                    <label>Telefone <span className="required">*</span></label>
                    <input
                      type="text"
                      name="celular"
                      value={formData.celular}
                      onChange={handleChange}
                      placeholder="(11) 99999-9999"
                      inputMode="numeric"
                      maxLength="15"
                      className={errors.celular ? 'input-error' : ''}
                    />
                    {errors.celular && <span className="field-error">{errors.celular}</span>}
                  </div>
                  <div className="field-group">
                    <label>Email <span className="required">*</span></label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="email@example.com"
                      className={errors.email ? 'input-error' : ''}
                    />
                    {errors.email && <span className="field-error">{errors.email}</span>}
                  </div>
                </div>

                <div className="field-row">
                  <div className="field-group">
                    <label>CNH <span className="required">*</span></label>
                    <select name="cnh" value={formData.cnh} onChange={handleChange} className={errors.cnh ? 'input-error' : ''}>
                      <option value="">Selecione...</option>
                      <option value="sim">Sim</option>
                      <option value="nao">Não</option>
                    </select>
                    {errors.cnh && <span className="field-error">{errors.cnh}</span>}
                  </div>
                </div>

                <div className="field-row">
                  <div className="field-group">
                    <label>Estado Civil <span className="required">*</span></label>
                    <select name="estadoCivil" value={formData.estadoCivil} onChange={handleChange} className={errors.estadoCivil ? 'input-error' : ''}>
                      <option value="">Selecione...</option>
                      <option value="solteiro">Solteiro(a)</option>
                      <option value="casado">Casado(a)</option>
                      <option value="divorciado">Divorciado(a)</option>
                      <option value="viuvo">Viúvo(a)</option>
                    </select>
                    {errors.estadoCivil && <span className="field-error">{errors.estadoCivil}</span>}
                  </div>
                  <div className="field-group">
                    <label>Naturalidade (cidade que nasceu): <span className="required">*</span></label>
                    <input
                      type="text"
                      name="naturalidade"
                      value={formData.naturalidade}
                      onChange={handleChange}
                      placeholder="Ex: São Paulo - SP"
                      className={errors.naturalidade ? 'input-error' : ''}
                    />
                    {errors.naturalidade && <span className="field-error">{errors.naturalidade}</span>}
                  </div>
                </div>
              </>
            )}

            {currentSection === 1 && (
              <>
                <div className="field-row flex-layout">
                  <div className="field-group-small">
                    <label>CEP <span className="required">*</span></label>
                    <input
                      type="text"
                      name="cep"
                      value={formData.cep}
                      onChange={handleChange}
                      placeholder="00000-000"
                      inputMode="numeric"
                      maxLength="9"
                      className={errors.cep ? 'input-error' : ''}
                    />
                    {buscandoCep && <span className="help-text">Buscando...</span>}
                    {errors.cep && <span className="field-error">{errors.cep}</span>}
                  </div>
                  <div className="field-group-large">
                    <label>Endereço <span className="required">*</span></label>
                    <input
                      type="text"
                      name="endereco"
                      value={formData.endereco}
                      onChange={handleChange}
                      placeholder="Rua, Avenida..."
                      className={errors.endereco ? 'input-error' : ''}
                    />
                    {errors.endereco && <span className="field-error">{errors.endereco}</span>}
                  </div>
                  <div className="field-group-small">
                    <label>Número <span className="required">*</span></label>
                    <input
                      type="text"
                      name="numero"
                      value={formData.numero}
                      onChange={handleChange}
                      placeholder="123"
                      inputMode="numeric"
                      className={errors.numero ? 'input-error' : ''}
                    />
                    {errors.numero && <span className="field-error">{errors.numero}</span>}
                  </div>
                </div>

                <div className="field-row flex-layout">
                  <div className="field-group">
                    <label>Bairro <span className="required">*</span></label>
                    <input
                      type="text"
                      name="bairro"
                      value={formData.bairro}
                      onChange={handleChange}
                      placeholder="Bairro"
                      className={errors.bairro ? 'input-error' : ''}
                    />
                    {errors.bairro && <span className="field-error">{errors.bairro}</span>}
                  </div>
                  <div className="field-group">
                    <label>Cidade <span className="required">*</span></label>
                    <input
                      type="text"
                      name="cidade"
                      value={formData.cidade}
                      onChange={handleChange}
                      placeholder="Cidade"
                      className={errors.cidade ? 'input-error' : ''}
                    />
                    {errors.cidade && <span className="field-error">{errors.cidade}</span>}
                  </div>
                  <div className="field-group-small">
                    <label>Estado <span className="required">*</span></label>
                    <select name="estado" value={formData.estado} onChange={handleChange} className={errors.estado ? 'input-error' : ''}>
                      <option value="">UF</option>
                      <option value="SP">SP</option>
                      <option value="MG">MG</option>
                      <option value="RJ">RJ</option>
                      <option value="BA">BA</option>
                      <option value="SC">SC</option>
                      <option value="PR">PR</option>
                      <option value="RS">RS</option>
                      <option value="PE">PE</option>
                      <option value="CE">CE</option>
                      <option value="PA">PA</option>
                      <option value="GO">GO</option>
                      <option value="PB">PB</option>
                      <option value="MA">MA</option>
                      <option value="ES">ES</option>
                      <option value="PI">PI</option>
                      <option value="RN">RN</option>
                      <option value="AL">AL</option>
                      <option value="MT">MT</option>
                      <option value="MS">MS</option>
                      <option value="DF">DF</option>
                      <option value="SE">SE</option>
                      <option value="AC">AC</option>
                      <option value="RO">RO</option>
                      <option value="AM">AM</option>
                      <option value="RR">RR</option>
                      <option value="AP">AP</option>
                      <option value="TO">TO</option>
                    </select>
                    {errors.estado && <span className="field-error">{errors.estado}</span>}
                  </div>
                </div>

                <div className="field-row">
                  <div className="field-group">
                    <label>Complemento <span className="required">*</span></label>
                    <input
                      type="text"
                      name="complemento"
                      value={formData.complemento}
                      onChange={handleChange}
                      placeholder="Apto, bloco..."
                      className={errors.complemento ? 'input-error' : ''}
                    />
                    {errors.complemento && <span className="field-error">{errors.complemento}</span>}
                  </div>
                </div>
              </>
            )}

            {currentSection === 2 && (
              <>
                <div className="field-row">
                  <div className="field-group">
                    <label>Tipo de Trabalho <span className="required">*</span></label>
                    <select name="tipoTrabalho" value={formData.tipoTrabalho} onChange={handleChange} className={errors.tipoTrabalho ? 'input-error' : ''}>
                      <option value="">Selecione...</option>
                      <option value="carteira_assinada">Carteira Assinada</option>
                      <option value="autonomo_cnpj">Autônomo com CNPJ</option>
                      <option value="autonomo_sem_cnpj">Autônomo sem CNPJ</option>
                      <option value="aposentado">Aposentado</option>
                    </select>
                    {errors.tipoTrabalho && <span className="field-error">{errors.tipoTrabalho}</span>}
                  </div>
                  <div className="field-group">
                    <label>Empresa <span className="required">*</span></label>
                    <input
                      type="text"
                      name="empresaTrabalha"
                      value={formData.empresaTrabalha}
                      onChange={handleChange}
                      placeholder="Nome da empresa"
                      className={errors.empresaTrabalha ? 'input-error' : ''}
                    />
                    {errors.empresaTrabalha && <span className="field-error">{errors.empresaTrabalha}</span>}
                  </div>
                </div>

                <div className="field-row">
                  <div className="field-group">
                    <label>Cargo <span className="required">*</span></label>
                    <input
                      type="text"
                      name="cargo"
                      value={formData.cargo}
                      onChange={handleChange}
                      placeholder="Seu cargo"
                      className={errors.cargo ? 'input-error' : ''}
                    />
                    {errors.cargo && <span className="field-error">{errors.cargo}</span>}
                  </div>
                  <div className="field-group">
                    <label>Salário <span className="required">*</span></label>
                    <input
                      type="text"
                      name="salario"
                      value={formData.salario}
                      onChange={handleChange}
                      placeholder="R$ 0,00"
                      inputMode="numeric"
                      className={errors.salario ? 'input-error' : ''}
                    />
                    {errors.salario && <span className="field-error">{errors.salario}</span>}
                  </div>
                </div>

                <div className="field-row">
                  <div className="field-group">
                    <label>Telefone da Empresa <span className="required">*</span></label>
                    <input
                      type="text"
                      name="telefoneEmpresa"
                      value={formData.telefoneEmpresa}
                      onChange={handleChange}
                      placeholder="(11) 3333-3333"
                      inputMode="numeric"
                      maxLength="15"
                      className={errors.telefoneEmpresa ? 'input-error' : ''}
                    />
                    {errors.telefoneEmpresa && <span className="field-error">{errors.telefoneEmpresa}</span>}
                  </div>
                  <div className="field-group">
                    <label>Tempo de Serviço <span className="required">*</span></label>
                    <input
                      type="text"
                      name="tempoServico"
                      value={formData.tempoServico}
                      onChange={handleChange}
                      placeholder="Ex: 2 anos"
                      className={errors.tempoServico ? 'input-error' : ''}
                    />
                    {errors.tempoServico && <span className="field-error">{errors.tempoServico}</span>}
                  </div>
                </div>

                <div className="field-row">
                  <div className="field-group">
                    <label>Endereço da Empresa <span className="required">*</span></label>
                    <input
                      type="text"
                      name="enderecoEmpresa"
                      value={formData.enderecoEmpresa}
                      onChange={handleChange}
                      placeholder="Endereço completo"
                      className={errors.enderecoEmpresa ? 'input-error' : ''}
                    />
                    {errors.enderecoEmpresa && <span className="field-error">{errors.enderecoEmpresa}</span>}
                  </div>
                </div>

                {formData.tipoTrabalho === 'autonomo_cnpj' && (
                  <div className="field-row">
                    <div className="field-group">
                      <label>CNPJ <span className="required">*</span></label>
                      <input
                        type="text"
                        name="cnpjProprietario"
                        value={formData.cnpjProprietario}
                        onChange={handleChange}
                        placeholder="00.000.000/0000-00"
                        inputMode="numeric"
                        className={errors.cnpjProprietario ? 'input-error' : ''}
                      />
                      {errors.cnpjProprietario && <span className="field-error">{errors.cnpjProprietario}</span>}
                    </div>
                  </div>
                )}
              </>
            )}

            {currentSection === 3 && (
              <div className="field-row">
                <div className="field-group">
                  <label>Observações Adicionais</label>
                  <textarea
                    name="observacoes"
                    value={formData.observacoes}
                    onChange={handleChange}
                    rows="8"
                    placeholder="Informações adicionais sobre o cliente..."
                    style={{ resize: 'vertical' }}
                  />
                </div>
              </div>
            )}

            {currentSection === 4 && (
              <>
                <ReviewCard title="Dados pessoais" onEdit={() => setCurrentSection(0)} rows={[
                  ['Nome', formData.nomeCompleto], ['CPF', formData.cpf], ['RG', formData.rg],
                  ['Nascimento', formData.dataNascimento?.split('-').reverse().join('/')],
                  ['Telefone', formData.celular], ['Email', formData.email],
                  ['CNH', formData.cnh === 'sim' ? 'Sim' : 'Não'], ['Estado civil', formData.estadoCivil],
                  ['Naturalidade', formData.naturalidade]
                ]} />
                <ReviewCard title="Endereço" onEdit={() => setCurrentSection(1)} rows={[
                  ['CEP', formData.cep], ['Endereço', [formData.endereco, formData.numero, formData.complemento].filter(Boolean).join(', ')],
                  ['Bairro', formData.bairro], ['Cidade / UF', [formData.cidade, formData.estado].filter(Boolean).join(' / ')]
                ]} />
                <ReviewCard title="Dados profissionais" onEdit={() => setCurrentSection(2)} rows={[
                  ['Tipo de trabalho', formData.tipoTrabalho], ['Empresa', formData.empresaTrabalha],
                  ['Cargo', formData.cargo], ['Salário', formData.salario],
                  ['Telefone da empresa', formData.telefoneEmpresa], ['Tempo de serviço', formData.tempoServico]
                ]} />
                <ReviewCard title="Observações" onEdit={() => setCurrentSection(3)} rows={[
                  ['Observações adicionais', formData.observacoes]
                ]} />
              </>
            )}
    </CreationWizard>
  );
};

export default PreencherFicha;
